import { isNil } from 'ramda';
import * as yup from 'yup';

import i18n from 'config/i18n';
import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

const textField = () =>
  yup
    .string()
    .default('')
    .transform((item) => (isNil(item) ? '' : item));

export const tasksCronJobsSchema = yup.object().shape({
  cron: textField(),
  config: yup
    .object()
    .shape({
      reportDefinitionId: textField(),
      period: yup
        .string()
        .default(undefined)
        .transform((item) => (isNil(item) ? '' : item))
    })
    // Conditioned on `jobName`, which this schema deliberately does not declare - the form owns
    // that field and `cast` would widen its type to a plain string. yup reads the sibling off the
    // value being validated either way; tasksCronJobsSchema.spec.ts pins that, including through
    // the field spread CronJobsCRUDForm rebuilds the schema with.
    //
    // A report that names no report cannot run: ReportExportService resolves the id to a method,
    // and the scheduler rejects anything but "dtr" and "capplan" outright. The field defaults to
    // "", so without this the untouched form submits one and comes back with a server error that
    // names no field.
    .when('jobName', (jobName, schema) =>
      jobName === 'report'
        ? schema.shape({
            reportDefinitionId: textField().required(
              t('validation.valueIsRequired')
            )
          })
        : schema
    )
});
